import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import events from '@/hooks/events';
import actions from '../constants';

const useUpdateLayout = () => {
  const handler = useDispatch();
  return useCallback(({ layout }) => handler({ type: actions.UPDATE_LAYOUT, layout }), []);
};

export default {
  useUpdateLayout,
  useUpdateShowLabels: () => events.useSimpleDispatch(actions.UPDATE_SHOW_LABELS),
  useToggleRibbon: () => events.useSimpleDispatch(actions.TOGGLE_RIBBON),
};
